import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';

import HomeIcon from '@mui/icons-material/Home';

import * as constNames from '../models/constant';
import { Routes as AppRoutes } from '../models/routes';
import * as actionTypes from '../store/actions/index';

function MTClientRequirementCircleComponent({ surveyData, currentDeal, cssState }) {
  const [anchorCREl, setAnchorCREl] = React.useState(false);

  const data = useSelector((state) => state?.optRed?.data);
  const emails = useSelector((state) => state?.comRed?.displayMails);

  const { surveyId } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    if (data && data?.dealId && emails?.length === 0) {
      dispatch(actionTypes.flexpertEmailAction(data?.dealId, 'CLIENT'));
    }
  }, [data, dispatch, emails?.length]);

  return (
    <>
      <ClientRequireCircle anchorCREl={anchorCREl}>
        <Link
          to={{
            pathname: `${AppRoutes.MOBILE_BASE}/${surveyId}/totaloptions`,
            state: { isCamePre: true },
          }}
        >
          <HomeIcon />
        </Link>
      </ClientRequireCircle>
    </>
  );
}

const ClientRequireCircle = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${(props) => (props.anchorCREl ? 'rgb(131 131 131)' : '#012a2d')};
  border: ${(props) => (props.anchorCREl ? 'solid 1px #fafafa' : 'none')};
  box-shadow: ${(props) => (props.anchorCREl ? '0px 3px 10px rgba(0, 0, 0, 0.20)' : 'none')};
  position: fixed;
  bottom: 70px;
  right: 16px;
  z-index: 110;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 24px;
    height: 24px;
  }
  & svg {
    color: #fff;
  }

  .icon-container {
    position: relative;
    width: 50px;
    height: 50px;
    overflow: hidden;
    display: grid;
    align-items: center;
    justify-items: center;
  }

  @media (orientation: ${constNames.DEVICE_ORIENTATION.LANDSCAPE}) {
    bottom: 15px;
    right: 70px;
  }
`;

export default MTClientRequirementCircleComponent;
